<template>
  <div class="mb-4 card" :class="{ 'card-fit-produccion': layoutProduccion }">
    <div class="p-3 card-body" :class="{ 'card-body-produccion': layoutProduccion, 'card-body-license': layoutLicencia }">
      <!-- Layout Producción: título e icono arriba; cantidad y porcentaje en la parte inferior -->
      <div v-if="layoutProduccion" class="d-flex flex-column card-inner-produccion">
        <div class="d-flex align-items-start gap-2 card-title-row">
          <p class="mb-0 card-title-label" :class="[titleSectionStyle ? 'section-title' : 'text-sm text-uppercase font-weight-bold', titleColor]">{{ title }}</p>
          <div class="card-icon-column-produccion flex-shrink-0">
            <div class="text-center icon icon-shape"
             :class="`${iconBackground} ${this.$store.state.isRTL ? 'border-radius-md' : 'border-radius-2xl'}`">
              <i class="text-lg opacity-10" :class="iconClass" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-end justify-content-between gap-2 card-bottom-produccion">
          <h5 class="font-weight-bolder mb-0" :class="valueColor">{{ value }}</h5>
          <span class="card-percentage-bottom font-weight-bold" :class="percentageColor">{{ percentage }}</span>
        </div>
      </div>
      <!-- Layout Licencia: título e icono arriba; Rechazado y fecha en la misma línea -->
      <div v-else-if="layoutLicencia" class="card-inner-license">
        <div class="d-flex align-items-start justify-content-between gap-2">
          <p class="mb-0 card-title-label section-title" :class="titleColor">{{ title }}</p>
          <div class="card-license-right">
            <div class="text-center icon icon-shape" :class="`${iconBackground} ${this.$store.state.isRTL ? 'border-radius-md' : 'border-radius-2xl'}`">
              <i class="text-lg opacity-10" :class="iconClass" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-baseline justify-content-between gap-2 mt-2 card-license-value-row">
          <h5 class="font-weight-bolder mb-0" :class="valueColor">{{ value }}</h5>
          <span class="card-license-date">{{ percentage }}</span>
        </div>
      </div>
      <!-- Layout normal -->
      <div v-else class="d-flex" :class="[directionReverse ? reverseDirection : '', titleSectionStyle && directionReverse ? 'card-layout-license' : '']">
        <div class="card-icon-wrap">
          <div class="text-center icon icon-shape"
           :class="`${iconBackground} ${this.$store.state.isRTL ? 'border-radius-md' : 'border-radius-2xl'}`">
            <i class="text-lg opacity-10" :class="iconClass" aria-hidden="true"></i>
          </div>
        </div>
        <div :class="[contentClass, titleSectionStyle && directionReverse ? 'card-content-license' : '']" class="flex-grow-1">
            <div class="numbers" v-if="this.$store.state.isRTL">
              <p class="mb-0 card-title-label" :class="[titleSectionStyle ? 'section-title' : 'text-sm text-uppercase font-weight-bold', titleColor]">{{ title }}</p>
              <h5 class="font-weight-bolder" :class="valueColor">{{ value }}
              <span class="text-sm"  :class="percentageColor">{{ percentage }}</span> 
              <span class="font-weight-light text-sm"> {{detail}}</span>
              </h5>
            </div>
            <div class="numbers" v-else>
              <p class="mb-0 card-title-label" :class="[titleSectionStyle ? 'section-title' : 'text-sm text-uppercase font-weight-bold', titleColor]">{{ title }}</p>
              <h5 class="font-weight-bolder" :class="valueColor">{{ value }}</h5>
              <span class="text-sm"  :class="percentageColor">{{ percentage }}</span> 
              {{detail}}
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "card",
  data() {
    return {
      reverseDirection: "flex-row-reverse justify-content-between",
    };
  },
  props: {
    directionReverse: Boolean,
    title: {
      type: String,
      required: true,
    },
    detail: {
      type: String,
      required: true,
    },
    titleColor: {
      type: String,
    },
    value: {
      required: true,
    },
    valueColor: {
      type: String,
    },
    percentage: String,
    iconClass: {
      type: String,
      required: true,
    },
    percentageColor: {
      type: String,
      default: "text-success",
    },
    iconBackground: {
      type: String,
      default: "bg-white",
    },
    contentClass: {
      type: String,
    },
    titleSectionStyle: {
      type: Boolean,
      default: false,
    },
    layoutProduccion: {
      type: Boolean,
      default: false,
    },
    layoutLicencia: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.card-title-label.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}

.card-title-label.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

.card-body-produccion {
  display: block;
  padding: 0.6rem 1rem !important;
}

.card-inner-produccion {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.card-body-produccion .card-title-row {
  flex-shrink: 0;
}

.card-body-produccion .card-title-label.section-title {
  line-height: 1.3;
  white-space: nowrap;
}

.card-bottom-produccion {
  padding-top: 0.5rem;
}

.card-percentage-bottom {
  font-size: 1rem;
}

.card-icon-column-produccion {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 3rem;
  margin-left: auto;
}

.card-percentage-below-icon {
  font-size: 1rem;
  line-height: 1.2;
}

.card-fit-produccion {
  width: 100%;
  max-width: 100%;
}

/* Tarjeta Licencia: icono a la derecha, texto bajado */
.card-layout-license {
  align-items: flex-end;
}
.card-layout-license .card-icon-wrap {
  margin-left: auto;
  flex-shrink: 0;
}
.card-content-license .card-title-label {
  margin-bottom: 0;
}
.card-content-license .numbers h5,
.card-content-license .numbers h5 + span {
  margin-top: 0.6rem;
}
.card-content-license .numbers h5 {
  margin-bottom: 0.15rem;
}

/* Layout Licencia: título arriba, valor bajado izquierda, icono + fecha derecha */
.card-body-license {
  display: block;
}
.card-inner-license .card-title-label.section-title {
  white-space: nowrap;
}
.card-license-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  align-self: flex-start;
  margin-top: -0.15rem;
}
.card-license-date {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1f2d5a;
}
.card-license-date-bottom {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1f2d5a;
}
.card-license-value {
  margin-top: 0.5rem;
}
</style>
